import { React, useState, useEffect, Toast, CustomTable, showDeleteOrRestoreMessage, Icon, FormModal, useUser } from "../../utils/commonImports";
import { formConfigs } from '../../utils/formsConfig';
import { _api } from '../../auth/Api';
import { getPageRights } from "../../utils/accessPages";

const pagec = [
  { title: "Page Id", dataIndex: "id" },
  { title: "Page Name", dataIndex: "pageName" },
  {
    title: "Status", dataIndex: "isActive",
    render: (isActive) => (
      <span className={`badge ${isActive ? 'bg-success' : 'bg-danger'}`}>
        {isActive ? 'Active' : 'Inactive'}
      </span>
    )
  },
];

const Pages = () => {
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState({});
  const [pages, setPages] = useState([]);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const rights = getPageRights(userPages, 10);

  useEffect(() => {
    _getPages();
  }, [])

  const _getPages = async () => {
    try {
      await _api('GET', 'Pages/GetAllActivePages', null, (r) => {
        if (r.isSuccess) {
          setPages(r.data);
        }
      });
    } catch (error) {
      console.log(error)
    }
  };

  const _saveOrUpdatePage = async (data) => {
    let config = { url: '', method: '' };
    if (data && data.id > 0) {
      config.url = 'Pages/UpdatePage'; config.method = 'POST';
      data.pageId = data.id
      delete data.id;
    } else {
      config.url = 'Pages/CreatePage'; config.method = 'POST'; data.parentId = 0; data.hasChild = false;
    }
    try {
      await _api(config.method, config.url, data, (res) => {
        if (res.isSuccess) {
          _getPages();
          Toast.fire({ icon: 'success', title: res.message });
          setData({});
          setModalShow(false);
        } else {
          Toast.fire({ icon: 'error', title: res.message });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const _deletePage = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    if (isConfirmed) {
      try {
        await _api('POST', `Pages/DeletePage`, { pageId: d?.id }, function (res) {
          if (res.isSuccess) {
            _getPages();
            Toast.fire({ icon: 'success', title: res.message })
            // showToast('success', res.message)
            _getPages();
          } else {
            Toast.fire({ icon: 'error', title: res.message })
            //showToast('error', res.message)
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const launchModal = (data, type) => {
    setData(data);
    setModalShow(type);
  };

  return (
    <>
      {/* <Breadcrumb title="Roles Management" /> */}
      {rights && rights.add && (
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add Pages
            <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
        </div>)}
      <CustomTable columns={pagec} dataSource={pages}
        options={{
          withActions: true, showEdit: true, showDelete: true, showView: false, loading: false,
          rowKey: "id", bordered: true, size: "small", emptyText: "No Pages found",  //  pageKey:"Roles Management",
          pageKey: 10,
        }}
        onEdit={(rowData) => launchModal(rowData, true)}
        onDelete={(d) => _deletePage(d)}
      />

      <FormModal
        page="Pages"
        size="lg"
        config={formConfigs.setup_pages}
        selectedData={data} // selected row
        show={modalShow}
        modalshow={(d, type) => launchModal(d, type)}
        modalsave={(d) => _saveOrUpdatePage(d)}
      />
    </>
  )
}

export default Pages